import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import validateFirstName from './validator';
import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError, fetchRealtimeValidations } from '../../data/actions';

/**
 * FirstName field wrapper. It accepts following handlers
 * - handleChange for setting value change and
 * - handleErrorChange for setting error
 *
 * It is responsible for
 * - Performing name field validations
 * - Clearing error on focus
 * - Setting value on change
 */
const FirstNameField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const validationApiRateLimited = useSelector(state => state.register.validationApiRateLimited);

  const {
    handleErrorChange,
    shouldFetchUsernameSuggestions,
  } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validateFirstName(value, formatMessage);
    if (fieldError) {
      handleErrorChange('first_name', fieldError);
    } else if (shouldFetchUsernameSuggestions && !validationApiRateLimited) {
      dispatch(fetchRealtimeValidations({ first_name: value }));
    }
  };

  const handleOnFocus = () => {
    handleErrorChange('first_name', '');
    dispatch(clearRegistrationBackendError('first_name'));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

FirstNameField.defaultProps = {
  errorMessage: '',
  shouldFetchUsernameSuggestions: false,
};

FirstNameField.propTypes = {
  errorMessage: PropTypes.string,
  shouldFetchUsernameSuggestions: PropTypes.bool,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default FirstNameField;
